import React from "react";

const NormalRecommendationInfo = ({ recommendation_props, isAsset }) => {
    return (
        <>
            <div className="col-md-12 basic-box main-heading mt-2">
                <h3>Table Properties</h3>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Table Style</h4>
                    <h3>{(recommendation_props?.table?.table_style_id && recommendation_props?.table?.table_style) || "-"}</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Table Page Fit</h4>
                    <h3>{recommendation_props?.table?.table_page_fit === true ? "True" : "False" || "-"}</h3>
                </div>
            </div>
            <div className="col-md-6 basic-box"></div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Custom Heading Font Name</h4>
                    <h3>{(recommendation_props?.table?.custom_head?.font_id && recommendation_props?.table?.custom_head?.font_family) || "-"}</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Custom Heading Font Size</h4>
                    <h3>{recommendation_props?.table?.custom_head?.font_size || "-"}px</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Custom Heading Font Color</h4>
                    <h3>
                        {recommendation_props?.table?.custom_head?.font_color || "-"}

                        <span
                            className="color"
                            style={{
                                backgroundColor: recommendation_props?.table?.custom_head?.font_color
                                    ? `#${recommendation_props?.table?.custom_head?.font_color}`
                                    : ""
                            }}
                        ></span>
                    </h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Custom Heading Background Color</h4>
                    <h3>
                        {recommendation_props?.table?.custom_head?.bg_color || ""}

                        <span
                            className="color"
                            style={{
                                backgroundColor: recommendation_props?.table?.custom_head?.bg_color
                                    ? `#${recommendation_props?.table?.custom_head?.bg_color}`
                                    : ""
                            }}
                        ></span>
                    </h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Custom Heading Font Alignmnet</h4>
                    <h3>{recommendation_props?.table?.custom_head?.alignment || "-"}</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Custom Heading Cell Margin Top</h4>
                    <h3>
                        {recommendation_props?.table?.custom_head?.cell_margin?.top
                            ? `${recommendation_props?.table?.custom_head?.cell_margin?.top} inch`
                            : "-"}
                    </h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Custom Heading Cell Margin Left</h4>
                    <h3>
                        {recommendation_props?.table?.custom_head?.cell_margin?.left
                            ? `${recommendation_props?.table?.custom_head?.cell_margin?.left} inch`
                            : "-"}
                    </h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Custom Heading Cell Margin Right</h4>
                    <h3>
                        {recommendation_props?.table?.custom_head?.cell_margin?.right
                            ? `${recommendation_props?.table?.custom_head?.cell_margin?.right} inch`
                            : "-"}
                    </h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Custom Heading Cell Margin Bottom</h4>
                    <h3>
                        {recommendation_props?.table?.custom_head?.cell_margin?.bottom
                            ? `${recommendation_props?.table?.custom_head?.cell_margin?.bottom} inch`
                            : "-"}
                    </h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Custom Heading Blank Line Height</h4>
                    <h3>
                        {recommendation_props?.table?.custom_head?.blank_line_height
                            ? `${recommendation_props?.table?.custom_head?.blank_line_height} pt`
                            : "-"}
                    </h3>
                </div>
            </div>
            <div className="col-md-6 basic-box"></div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Heading Font Name</h4>
                    <h3>{(recommendation_props?.table?.heading?.font_id && recommendation_props?.table?.heading?.font_family) || "-"}</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Heading Font Size</h4>
                    <h3>{recommendation_props?.table?.heading?.font_size || "-"}px</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Heading Font Color</h4>
                    <h3>
                        {recommendation_props?.table?.heading?.font_color || ""}

                        <span
                            className="color"
                            style={{
                                backgroundColor: recommendation_props?.table?.heading?.font_color
                                    ? `#${recommendation_props?.table?.heading?.font_color}`
                                    : ""
                            }}
                        ></span>
                    </h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Heading Background Color</h4>
                    <h3>
                        {recommendation_props?.table?.heading?.bg_color || ""}

                        <span
                            className="color"
                            style={{
                                backgroundColor: recommendation_props?.table?.heading?.bg_color
                                    ? `#${recommendation_props?.table?.heading?.bg_color}`
                                    : ""
                            }}
                        ></span>
                    </h3>
                </div>
            </div>

            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Heading Font Alignment</h4>
                    <h3>{recommendation_props?.table?.heading?.alignment || ""}</h3>
                </div>
            </div>

            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Heading Cell Margin Top</h4>
                    <h3>
                        {recommendation_props?.table?.heading?.cell_margin?.top
                            ? `${recommendation_props?.table?.heading?.cell_margin?.top} inch`
                            : "-"}
                    </h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Heading Cell Margin Left</h4>
                    <h3>
                        {recommendation_props?.table?.heading?.cell_margin?.left
                            ? `${recommendation_props?.table?.heading?.cell_margin?.left} inch`
                            : "-"}
                    </h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Heading Cell Margin Right</h4>
                    <h3>
                        {recommendation_props?.table?.heading?.cell_margin?.right
                            ? `${recommendation_props?.table?.heading?.cell_margin?.right} inch`
                            : "-"}
                    </h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Heading Cell Margin Bottom</h4>
                    <h3>
                        {recommendation_props?.table?.heading?.cell_margin?.bottom
                            ? `${recommendation_props?.table?.heading?.cell_margin?.bottom} inch`
                            : "-"}
                    </h3>
                </div>
            </div>
            <div className="col-md-9 basic-box"></div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Body Font Name</h4>
                    <h3>{(recommendation_props?.table?.data?.font_id && recommendation_props?.table?.data?.font_family) || ""}</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Body Font Size</h4>
                    <h3>{recommendation_props?.table?.data?.font_size || ""}px</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Body Font Color</h4>
                    <h3>
                        {recommendation_props?.table?.data?.font_color || ""}

                        <span
                            className="color"
                            style={{
                                backgroundColor: recommendation_props?.table?.data?.font_color
                                    ? `#${recommendation_props?.table?.data?.font_color}`
                                    : ""
                            }}
                        ></span>
                    </h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Body Font Alignment</h4>
                    <h3>{recommendation_props?.table?.data?.alignment || "-"}</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Body Cell Margin Top</h4>
                    <h3>
                        {recommendation_props?.table?.data?.cell_margin?.top ? `${recommendation_props?.table?.data?.cell_margin?.top} inch` : "-"}
                    </h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Body Cell Margin Left</h4>
                    <h3>
                        {recommendation_props?.table?.data?.cell_margin?.left ? `${recommendation_props?.table?.data?.cell_margin?.left} inch` : "-"}
                    </h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Body Cell Margin Right</h4>
                    <h3>
                        {recommendation_props?.table?.data?.cell_margin?.right
                            ? `${recommendation_props?.table?.data?.cell_margin?.right} inch`
                            : "-"}
                    </h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Body Cell Margin Bottom</h4>
                    <h3>
                        {recommendation_props?.table?.data?.cell_margin?.bottom
                            ? `${recommendation_props?.table?.data?.cell_margin?.bottom} inch`
                            : "-"}
                    </h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Image Width</h4>
                    <h3>{recommendation_props?.table?.data?.image_band?.img_width ? `${recommendation_props?.table?.data?.image_band?.img_width} inch` : "-"}</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Image Height</h4>
                    <h3>{recommendation_props?.table?.data?.image_band?.img_height ? `${recommendation_props?.table?.data?.image_band?.img_height} inch` : "-"}</h3>
                </div>
            </div>
            <div className="col-md-6 basic-box"></div>

            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Sub Total Font Name</h4>
                    <h3>{(recommendation_props?.table?.sub_total?.font_id && recommendation_props?.table?.sub_total?.font_family) || "-"}</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Sub Total Font Size</h4>
                    <h3>{recommendation_props?.table?.sub_total?.font_size || "-"}px</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Sub Total Font Color</h4>
                    <h3>
                        {recommendation_props?.table?.sub_total?.font_color || "-"}

                        <span
                            className="color"
                            style={{
                                backgroundColor: recommendation_props?.table?.sub_total?.font_color
                                    ? `#${recommendation_props?.table?.sub_total?.font_color}`
                                    : ""
                            }}
                        ></span>
                    </h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Sub Total Background Color</h4>
                    <h3>
                        {recommendation_props?.table?.sub_total?.bg_color || "-"}

                        <span
                            className="color"
                            style={{
                                backgroundColor: recommendation_props?.table?.sub_total?.bg_color
                                    ? `#${recommendation_props?.table?.sub_total?.bg_color}`
                                    : ""
                            }}
                        ></span>
                    </h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Sub Total Font Alignment</h4>
                    <h3>{recommendation_props?.table?.sub_total?.alignment || "-"}</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Sub Total Cell Margin Top</h4>
                    <h3>
                        {recommendation_props?.table?.sub_total?.cell_margin?.top
                            ? `${recommendation_props?.table?.sub_total?.cell_margin?.top} inch`
                            : "-"}
                    </h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Sub Total Cell Margin Left</h4>
                    <h3>
                        {recommendation_props?.table?.sub_total?.cell_margin?.left
                            ? `${recommendation_props?.table?.sub_total?.cell_margin?.left} inch`
                            : "-"}
                    </h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Sub Total Cell Margin Right</h4>
                    <h3>
                        {recommendation_props?.table?.sub_total?.cell_margin?.right
                            ? `${recommendation_props?.table?.sub_total?.cell_margin?.right} inch`
                            : "-"}
                    </h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Sub Total Cell Margin Bottom</h4>
                    <h3>
                        {recommendation_props?.table?.sub_total?.cell_margin?.bottom
                            ? `${recommendation_props?.table?.sub_total?.cell_margin?.bottom} inch`
                            : "-"}
                    </h3>
                </div>
            </div>
            <div className="col-md-9 basic-box"></div>

            <div className="col-md-12 basic-box main-heading mt-2">
                <h3>Table Column Configuration</h3>
            </div>

            {recommendation_props?.properties?.map((columnData, index) => (
                <div className="col-md-3 basic-box">
                    <div className="codeOtr">
                        <h4>{columnData?.heading || "-"}</h4>
                        <h3>{columnData?.width || "-"} inch</h3>
                    </div>
                </div>
            ))}
            {!isAsset && (
                <>
                    <div className="col-md-12 basic-box main-heading mt-2"></div>
                    <div className="col-md-3 basic-box">
                        <div className="codeOtr">
                            <h4>Starting Year Count</h4>
                            <h3>{recommendation_props?.year?.start_count || "-"}</h3>
                        </div>
                    </div>
                    <div className="col-md-3 basic-box">
                        <div className="codeOtr">
                            <h4>Ending Year Count</h4>
                            <h3>{recommendation_props?.year?.end_count || "-"}</h3>
                        </div>
                    </div>
                    <div className="col-md-6 basic-box"></div>
                </>
            )}
        </>
    );
};

export default NormalRecommendationInfo;
